import Vue from 'vue'
import App from './App.vue'
import router from './modules/router'
import store from './store'
import Api from './modules/api/api'
import PortalVue from 'portal-vue'

import Loading from '@/mixins/loading.mixin.js'
import Formatters from '@/mixins/formatters.mixin.js'
import GetUrlPhoto from '@/mixins/getUrlPhoto.mixin.js'
import staticData from '@/staticData.js'

import ElementUI from "element-ui";
import elementLocale from "element-ui/lib/locale/lang/ru-RU";

import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/element-ui/_element.scss';



Vue.use(ElementUI, {locale: elementLocale, size: "mini"});

Vue.use(Api, store, router)
Vue.use(PortalVue)
Vue.prototype.$staticData = staticData
Vue.config.productionTip = false
Vue.mixin(Loading);


Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
})

new Vue({
    router,
    store,
    mixins: [Formatters, GetUrlPhoto],
    render: h => h(App)
}).$mount('#app')
